import { PromoCombined } from './promo-combined.js';
import setViewportHeight from './set-dimensions-variables.js';
import sf9Cookiebot from './cookiebot.js';
import './cart-actions.js';
import './advanced-multibuys.js';

window.addEventListener('load', event => {
  sf9Cookiebot.init();
});

(() => {
  PromoCombined.init();

  if (window.location.href.includes('/cart')) {
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function debounce(fn, wait = 300) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  setViewportHeight.setHeightInit();
  window.addEventListener('resize', debounce(setViewportHeight.setHeightInit, 50));
})();
